// src/components/Team/TeamMember.js
import React from "react";
import styles from "./TeamMember.module.css";

const TeamMember = ({ name, image, linkedinUrl }) => {
  return (
    <div className={styles.memberCard}>
      <img src={image || "/placeholder.svg"} alt={name} className={styles.memberImage} />
      <div className={styles.memberInfo}>
        <h3 className={styles.memberName}>{name}</h3>
        <a
          href={linkedinUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkedinLink}
          aria-label={`${name}'s LinkedIn profile`}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.linkedinIcon}
          >
            <path
              d="M14.8156 0H1.18125C0.528125 0 0 0.515625 0 1.15313V14.8438C0 15.4813 0.528125 16 1.18125 16H14.8156C15.4688 16 16 15.4813 16 14.8469V1.15313C16 0.515625 15.4688 0 14.8156 0ZM4.74687 13.6344H2.37188V5.99687H4.74687V13.6344ZM3.55938 4.95625C2.79688 4.95625 2.18125 4.34062 2.18125 3.58125C2.18125 2.82188 2.79688 2.20625 3.55938 2.20625C4.31875 2.20625 4.93437 2.82188 4.93437 3.58125C4.93437 4.3375 4.31875 4.95625 3.55938 4.95625ZM13.6344 13.6344H11.2625V9.92188C11.2625 9.0375 11.2469 7.89687 10.0281 7.89687C8.79375 7.89687 8.60625 8.8625 8.60625 9.85938V13.6344H6.2375V5.99687H8.5125V7.04063H8.54375C8.85938 6.44063 9.63438 5.80625 10.7875 5.80625C13.1906 5.80625 13.6344 7.3875 13.6344 9.44375V13.6344Z"
              fill="#007AFF"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default TeamMember;